export const Register = 'Register';
export const ValidateLogin = 'Validate-Login';
export const ValidatePending = "validate-pending";
export const Logout = 'Logout';
export const Authenticated = 'Authenticated';
export const Services = "services";
export const ServicesOpen = "services-open";
export const Service = "service";
export const ActivateService = "activate-service";
export const DisableService = "disable-service";
export const DeleteService = "remove-service";
export const Barber = "barber";
export const ActiveBarbers = "active-barbers";
export const ServicesByBarber = "services-by-barber";
export const BarberWorkingDays = "barber-working-days";
export const BarberWorkingDaysOpen = "barber-working-days-open";
export const AccountStatus = "account-status-open";
export const Barbers = "barbers";
export const DeleteBarber = "remove-barber";
export const ActivateBarber = "activate-barber";
export const DisableBarber = "disable-barber";
export const Appointment = "Appointment"
export const Booking = "Booking";
export const Holiday = "Holiday";
export const Events = "Events";
export const ExtremeWorkingTimes = "extreme-working-hours";
export const Customer = "customer";
export const Customers = "customers";
export const UpdateAppointmentTimeSlot = "appointment-slot";
export const UpdateHolidayTimeSlot = "holiday-slot";
export const DeleteHoliday = "holiday-delete";
export const CancelAppointment = "appointment-cancel";
export const CancelAppointmentOpen = "appointment-cancel-open";
export const BarberWorkingTimes = "barber-working-times";
export const ServiceDurations = "service-durations";
export const ServiceDurationsOpen = "service-durations-open";
export const FutureAppointments = "future-appointments"
export const GetAvailableTimesForBarberByDateTime = "available-appointment-times-for-barber";
export const GetAvailableTimesForBarberByDateTimeOpen = "available-appointment-times-for-barber-open";
export const GetConfig = "config";
export const VerifyCheckoutSession = "verify-checkout-session";
export const VerifyAppointmentCheckoutSession = "verify-appointment-checkout-session";
export const CreateBillingPortalSession = "create-billing-portal-session";
export const GetPaymentServiceDetails = "payment-service-details";
export const AppointmentConfig = "appointment-config";
export const CreateCheckoutSession = "create-checkout-session";
export const LangConfig = "language-config";
export const Subscription = "subscription";
export const AllowedPlans = "allowed-plans";
export const BillingPortal = "billing-portal";
export const CalendarConfig = "calendar-config";
export const AccountDetailsConfig = "account-details-config";
export const ResetDemoAccount = "reset-demo-account";
export const CustomerisationCommunicationsConfig = "customerisation-communications-config";
export const SendTestConfirmationEmail = "send-test-confirmation-email";
export const NotificationsDetailsConfig = "notifications-details-config";
export const VerificationCode = "verification-code";
export const UpdateEmail = "email";
export const UpdatePassword = "password";
export const CustomerCommunication = "customer-communication";
export const AppointmentToCancel = "appointment-to-cancel";
export const ShopId = "shop-id";
export const PasswordResetRequest = "request-password-reset";
export const ResetPassword = "reset-password";
export const Notification = "notification";
export const Appointments = "appointments";
export const SupportTicket = "support-ticket";
export const ConnectStripeAccount = "connect-stripe-account";
export const ConnectStripeAccountAttention = "connect-stripe-account-attention";
export const ConnectStripeLoginLink = "stripe-account-link";
export const AcceptOnlinePaymentsOptionUpdate = "accept-online-payments";
export const DisconnectStripeAccount = "disconnect-stripe-account";
export const CreatePaymentIntent = "create-payment-intent";
export const CreateCheckoutSessionConnectedAccount = "create-appointment-checkout-session";
export const AcceptingPaymentsStatus = "accepting-payments-status";
export const Site = "site";
export const SiteLive = "site-live";
export const BookingPortalStatus = "booking-portal-status";
export const SiteTheme = "site-theme";
export const DeleteImage = "delete-image";
export const SiteTitle = "site-title";
export const SiteContactDetails = "site-contact-details";
export const SiteBusinessHours = "site-business-hours";
export const SiteSection = "site-section";
export const DisableSiteSection = "site-section-disable";
export const SiteSocials = "site-socials";
export const SitePreview = "site-preview";
export const ConfigAddress = "config-address";
export const Terms = "terms-and-conditions";
export const Website = "website-link";
export const Currency = "currency";
export const Leave = "leave";
export const Roster = "roster";
export const Theme = "theme";
export const Balance = "balance";
export const StripeAccountRequirments = "stripe-connect-requirements-state"
